





































import { PartyProductModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import {Component, Vue, Prop, Ref} from 'vue-property-decorator';
import LoanDialog from '@/libs/clients/components/LoanDialog.vue';

@Component({
    components: {
        LoanDialog
    }
})
export default class LoanCard extends Vue {


    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: LoanDialog;
    
    newId: string | null = Guid.EmptyGuid();

    openPartyProduct() {
        if (this.partyProduct.id == this.newId)
            return;
        this.dialog.open();
    }

}

